import CreateIdeaModal from './CreateIdeaModal';

export default CreateIdeaModal;